export const navbarData = [
  { label: 'GitHub', url: 'https://github.com/jacobarychuk' },
  { label: 'LinkedIn', url: 'https://www.linkedin.com/in/jacobarychuk' },
  { label: 'Contact', url: 'mailto:jzarychuk@gmail.com' },
];
